import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Button from "./Button";
import PictureImage from "./PictureImage";
import { handwritten } from "./editorial";

export default function FounderNote() {
  return (
    <section className="w-full py-24 md:py-36 px-6 md:px-12 overflow-hidden">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="max-w-5xl w-full mx-auto"
      >
        <div className="flex items-center gap-4 mb-10 max-w-3xl">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-salmon whitespace-nowrap">
            A note from us
          </span>
          <span className="flex-1 h-px bg-ink/15" />
        </div>

        <div className="bg-canvas border border-ink/15 rounded-3xl p-8 md:p-14 flex flex-col md:flex-row gap-12 items-start shadow-[0_14px_36px_-14px_rgba(5,5,5,0.18)]">
          {/* Founder polaroid */}
          <div className="w-full md:w-1/3 shrink-0">
            <div className="polaroid-frame p-3 pb-10 border shadow-[0_14px_36px_-14px_rgba(5,5,5,0.18)] rotate-[-3deg] transition-transform hover:rotate-0 transform-gpu">
              <div className="aspect-square overflow-hidden">
                <PictureImage
                  src="/josh-founder.jpg"
                  alt="The LetsLoop founding team"
                  width={900}
                  height={900}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <p
                className="mt-3 text-center text-xl text-gray-600"
                style={handwritten}
              >
                the team
              </p>
            </div>
          </div>

          {/* Letter */}
          <div className="w-full md:w-2/3 flex flex-col items-start text-left">
            <h3 className="text-3xl md:text-5xl font-serif tracking-tight mb-6 leading-[1.05]">
              Why we are
              <span className="italic text-salmon"> building this.</span>
            </h3>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              We started LetsLoop around a universal problem: most adults have
              no way to bump into the same people more than once.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Loops is what we built to fix it. A spontaneous community network
              for the things you do anyway. Free to join.
            </p>
            <p
              className="text-3xl text-salmon -rotate-2 mb-8"
              style={handwritten}
            >
              Josh &amp; The LetsLoop Team
            </p>

            <Link to="/how-it-works">
              <Button variant="primary" size="lg">
                See how it works
              </Button>
            </Link>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
